/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Tagsplaceholder1Inputs */

const id_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. kualitas, desain, performa`)
};

const ms_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cth. kualiti, reka bentuk, prestasi`)
};

const da_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. kvalitet, design, ydelse`)
};

const de_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Qualität, Design, Leistung`)
};

const en_us2_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. quality, design, performance`)
};

const es_es2_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. calidad, diseño, rendimiento`)
};

const es_mx2_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. calidad, diseño, rendimiento`)
};

const fil_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hal. kalidad, disenyo, pagganap`)
};

const fr_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. : qualité, design, performances`)
};

const it_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. qualità, design, prestazioni`)
};

const hu_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pl. minőség, dizájn, teljesítmény`)
};

const nl_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. kwaliteit, ontwerp, prestaties`)
};

const no_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. kvalitet, design, ytelse`)
};

const pl_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. jakość, design, wydajność`)
};

const pt_br2_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. quality, design, performance`)
};

const pt_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex., qualidade, design, desempenho`)
};

const ro_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de ex. calitate, design, performanță`)
};

const fi_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. laatu, muotoilu, suorituskyky`)
};

const sv_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. kvalitet, design, prestanda`)
};

const vi_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ví dụ: chất lượng, thiết kế, hiệu suất`)
};

const tr_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`örn. kalite, tasarım, performans`)
};

const cs_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`např. kvalita, design, výkon`)
};

const bg_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`напр. качество, дизайн, производителност`)
};

const ru_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например: качество, дизайн, производительность`)
};

const uk_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`напр. якість, дизайн, продуктивність`)
};

const ar_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: جودة، تصميم، أداء`)
};

const hi_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जैसे गुणवत्ता, डिज़ाइन`)
};

const th_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เช่น คุณภาพ การออกแบบ ประสิทธิภาพ`)
};

const ja_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例：品質、デザイン、パフォーマンス`)
};

const zh_cn2_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. quality, design, performance`)
};

const zh_hant1_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. quality, design, performance`)
};

const ko_forms_review_tagsplaceholder1 = /** @type {(inputs: Forms_Review_Tagsplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. quality, design, performance`)
};

/**
* | output |
* | --- |
* | "e.g. quality, design, performance" |
*
* @param {Forms_Review_Tagsplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_tagsplaceholder1 = /** @type {((inputs?: Forms_Review_Tagsplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Tagsplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_tagsplaceholder1(inputs)
	if (locale === "ms") return ms_forms_review_tagsplaceholder1(inputs)
	if (locale === "da") return da_forms_review_tagsplaceholder1(inputs)
	if (locale === "de") return de_forms_review_tagsplaceholder1(inputs)
	if (locale === "en-US") return en_us2_forms_review_tagsplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_tagsplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_tagsplaceholder1(inputs)
	if (locale === "fil") return fil_forms_review_tagsplaceholder1(inputs)
	if (locale === "fr") return fr_forms_review_tagsplaceholder1(inputs)
	if (locale === "it") return it_forms_review_tagsplaceholder1(inputs)
	if (locale === "hu") return hu_forms_review_tagsplaceholder1(inputs)
	if (locale === "nl") return nl_forms_review_tagsplaceholder1(inputs)
	if (locale === "no") return no_forms_review_tagsplaceholder1(inputs)
	if (locale === "pl") return pl_forms_review_tagsplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_tagsplaceholder1(inputs)
	if (locale === "pt") return pt_forms_review_tagsplaceholder1(inputs)
	if (locale === "ro") return ro_forms_review_tagsplaceholder1(inputs)
	if (locale === "fi") return fi_forms_review_tagsplaceholder1(inputs)
	if (locale === "sv") return sv_forms_review_tagsplaceholder1(inputs)
	if (locale === "vi") return vi_forms_review_tagsplaceholder1(inputs)
	if (locale === "tr") return tr_forms_review_tagsplaceholder1(inputs)
	if (locale === "cs") return cs_forms_review_tagsplaceholder1(inputs)
	if (locale === "bg") return bg_forms_review_tagsplaceholder1(inputs)
	if (locale === "ru") return ru_forms_review_tagsplaceholder1(inputs)
	if (locale === "uk") return uk_forms_review_tagsplaceholder1(inputs)
	if (locale === "ar") return ar_forms_review_tagsplaceholder1(inputs)
	if (locale === "hi") return hi_forms_review_tagsplaceholder1(inputs)
	if (locale === "th") return th_forms_review_tagsplaceholder1(inputs)
	if (locale === "ja") return ja_forms_review_tagsplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_tagsplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_tagsplaceholder1(inputs)
	return ko_forms_review_tagsplaceholder1(inputs)
});
export { forms_review_tagsplaceholder1 as "forms.review.tagsPlaceholder" }